<template>
  <div>
    <vs-row vs-type="flex" vs-justify="space-between">
      <vs-col class="mb-3 mx-auto" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" v-for="(portal,index) in portalTypes" :key="index">
        <vs-button  @click="selectportal(portal)" color="primary" type="filled">{{ portal | title }}</vs-button>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      portalTypes: [
        'online',
        'device',
        'delivery',
        'api'
      ]
    }
  },
  methods: {
    selectportal(portal) {
      this.$emit('selectPortalType',portal)
    }
  }
}
</script>
